export const DataSourcesVisibilityEnum = {
  PRIVATE: 'privateVisibility',
  PUBLIC: 'publicVisibility',
} as const;

export type DataSourcesVisibilityEnum = typeof DataSourcesVisibilityEnum[keyof typeof DataSourcesVisibilityEnum];
